import React from 'react';
import { X } from 'lucide-react';

const OAuthLoadingModal = ({ isOpen, onClose, provider = 'Google' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Logo */}
        <div className="text-center mb-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_haute-assets/artifacts/eca04feb_THC%20Final%20Logo%20%28Monogram%29.png" 
            alt="The Haute Circle" 
            className="h-20 mx-auto mb-4" 
          />
          <h2 className="text-2xl font-bold mb-2">The Haute Circle</h2>
          <p className="text-gray-600 text-sm">Connecting with {provider}...</p>
        </div>

        {/* Loading animation */}
        <div className="flex justify-center mb-6">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2" style={{ borderColor: '#D4AF37' }}></div>
        </div>

        {/* Instructions */}
        <div className="text-center space-y-2">
          <p className="text-sm text-gray-600">
            A new window will open for authentication.
          </p>
          <p className="text-xs text-gray-500">
            If the popup is blocked, please allow popups for this site.
          </p>
        </div>

        {/* Secure badge */}
        <div className="mt-6 pt-4 border-t border-gray-200 flex items-center justify-center space-x-2 text-xs text-gray-500">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <span>Secure authentication</span>
        </div>
      </div>
    </div>
  );
};

export default OAuthLoadingModal;
